import type { ComponentType, PropsWithChildren } from 'react';

/**
 * Re-types a component to a plain `ComponentType<P>`, hiding polymorphic
 * and forward-ref generics that the source library bakes in.
 *
 * Used at the boundary with libraries (Mantine, react-pdf, etc.) whose
 * exported component types reference package-internal types not visible
 * in `.d.ts` output. With composite-mode emit, those internal names
 * surface as TS2742 / TS4023 "cannot be named" errors.
 *
 * The runtime value is unchanged — TS just sees a narrower, nameable type.
 */
export const asPlainComponent = <P>(Component: unknown): ComponentType<PropsWithChildren<P>> =>
	Component as ComponentType<PropsWithChildren<P>>;
